<script>
    import Loader from '../../Loader.svelte';
    import { addFormModal } from '../../../Forms/ModalFormManager.svelte';
    import { notifier } from "@beyonk/svelte-notifications";
    import { uuid } from '../../../Database.svelte';
    import { confirm } from '../../Confirmation.svelte';
    import { showContextMenu } from '../../ContextMenu.svelte';

    export let assessment_type_model;
    export let section;

    const item_fields =  [
        {
            name: "name",
            label: "Item Name",
            type: "text",
            required: true
        },
        {
            name: "default_score",
            label: "Default Client Score",
            type: "number",
            dflt: 3
        },
        {
            name: "default_target",
            label: "Default Client Target",
            type: "number",
            dflt: 3
        }
    ]

    const category_fields = [
        {
            name: "name",
            label: "Category Name",
            type: "text",
            required: true
        }
    ]

    function load_data(section) {
        if (!section.categories) {
            section.categories = [];
        }
    }

    function addCategory() {
        addFormModal({
            title: "Add Category",
            fields: category_fields, 
        }).then((category) => {
            section.categories = [...section.categories, {
                id: uuid(),
                name: category.name,
                items: []
            }]
           // notifier.success("Category Added")
        }).catch(() => {})
    }

    function editCategory(category) {
        addFormModal({
            title: "Edit Category",
            fields: category_fields, 
            data: category
        }).then((category) => {
            section.categories = section.categories.map(c => {
                if (category.id == c.id) {
                    return category
                } else {
                    return c
                }
            })
            //notifier.success("Category Updated")
        }).catch(() => {})
    }

    function deleteCategory(category) {
        confirm(`Are you sure you want to delete "${category.name}"?`).then(() => {
            section.categories = section.categories.filter(c => c.id != category.id);
            notifier.success("Category Removed")
        }).catch(() => {}); // ignore cancellation
    }

    function addItem(category) {
        addFormModal({
            title: "Add Item",
            fields: item_fields
        }).then((item) => {
            category.items.push({
                id: uuid(),
                ...item
            });

            //notifier.success("Item Added");

            // tell svelte that categories had been updated
            section.categories = section.categories
        }).catch(() => {})
    }

    function editItem(category, item) {
        addFormModal({
            title: "Edit Item",
            fields: item_fields,
            data: item
        }).then((data) => {
            category.items = category.items.map(i => {
                if (i.id == data.id) {
                    return data
                } else {
                    return i
                }
            })

            section.categories = section.categories;
            //notifier.success("Item Updated")
        }).catch(() => {})
    }

    
    function deleteItem(category, item) {
        confirm(`Are you sure you want to delete "${item.name}"?`).then(() => {
            category.items = category.items.filter(i => i.id != item.id);

            section.categories = section.categories;
        }).catch(() => {}); // ignore cancellation

    }


    function handleItemMenu(evt, category, item) {
        showContextMenu(evt.clientX, evt.clientY, [
            {
                name: "Edit Item",
                action: () => {editItem(category, item)}
            },
            {
                name: "Delete Item",
                action: () => deleteItem(category, item)
            }
        ])
    }

    function handleCategoryMenu(evt, category) {
        showContextMenu(evt.clientX, evt.clientY, [
            {
                name: "Edit Category",
                action: () => {editCategory(category)}
            },
            {
                name: "Delete Category",
                action: () => {deleteCategory(category)}
            }
        ])
    }


    function save() {
        assessment_type_model.saveSection(section).then(() => {
            notifier.success("Section Saved")
        });
    }


    $: load_data(section)
</script>

<Loader loading={!section.categories}>
    <div class="container is-fluid">
        <button class="button is-success is-pulled-right" on:click={save}>Save</button>
        <h1 class="title is-1">Scores</h1>

        
        <aside class="menu">
            {#each section.categories as category (category.id)}
                <ul class="menu-list">
                    <li>
                        <p class="menu-label is-size-4" on:contextmenu|preventDefault={(evt) => handleCategoryMenu(evt, category)}>
                            {category.name}
                        </p>
                        <ul class="menu-list">
                            {#each category.items as item (item.id)}
                            <li>
                                <a on:contextmenu|preventDefault={(evt) => handleItemMenu(evt, category, item)}>
                                    {item.name} (Score: {item.default_score}, Target: {item.default_target})
                                </a>
                            </li>
                            {/each}
                            <li>
                                <a on:click={() => addItem(category)}>+ Add Item</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            {/each}
            <ul class="menu-list">
                <li class="pointer">
                    <a on:click={addCategory}>+ Add Category</a>
                </li>
            </ul> 
        </aside>
</Loader>